import { takeEvery, put, call, select } from "redux-saga/effects";
import { UpdatePersonInput } from "@radivision/graphql/lib/ts/graphql/mutations/update-person-input";
import { User } from "../../../../../utilities/user";
import { TOAST_FAIL, TOAST_ALERT, TOAST_SUCCESS } from "../../../../../redux/toast/constants";
import {
  prepareUploadMediaPayload,
  prepareMediaAssetPayload,
  ImageUpload,
} from "../../../../../utilities/image-uploader";
import isEmpty from "lodash.isempty";
import { fetchInProgress, cacheData } from "../../../../../redux/cache/actions";
import { SetProfileStatePayload } from "../types";
import { getClientMutationId } from "../../../../../utilities/general";
import { updatePerson } from "../api";
import { setToastMessage } from "../../../../../redux/toast/actions";
import { ONBOARDING_ENTHUSIAST } from "../constants";
import { getProfileInfo } from "../../../../../utilities/get-profile-info";
import { updateUser } from "../../../../../redux/actions";
import { setProfileState } from "../actions";
import { ENTHUSIAST } from "../../../../../redux/authentication/account-types";

function* onBoardingEnthusiastWorker() {
  try {
    const profileState = yield select((state) => state.profile);
    const currentUser = yield select((state) => state.account.user);
    const isValid = yield call(validateOnBoardingEnthusiastForm, profileState);

    if (!isValid) {
      return;
    }
    yield put(fetchInProgress({ key: "onboarding-enthusiast", status: true }));
    const file = profileState.profileImage;

    let mediaAssetId: string | null = null;
    if (file) {
      yield call(ImageUpload.uploadImageToS3, prepareUploadMediaPayload(file));
      mediaAssetId = yield call(ImageUpload.createMediaAssetFile, prepareMediaAssetPayload(file));
    }
    const previews = User.handleEditPersonPreview(mediaAssetId, null, currentUser.previews);

    const personInput: UpdatePersonInput & { accountType: { kind: string; description?: string; subKind?: string } } = {
      clientMutationId: getClientMutationId(),
      id: currentUser.id,
      revision: currentUser.revision,
      fullName: profileState.fullName,
      accountType: { kind: ENTHUSIAST.kind },
      ...(mediaAssetId ? { previews } : {}),
    };

    const updatedUser = yield call(updatePerson, personInput);
    if (updatedUser) {
      yield put(cacheData({ key: updatedUser.id, data: updatedUser }));
      yield put(updateUser({ user: updatedUser }));
      yield put(setProfileState({ revision: updatedUser.revision }));
    }

    yield put(setToastMessage({ msg: "Profile page was successfully created!", type: TOAST_SUCCESS }));
    const signupRedirectionUrl = yield select((state) => state.authentication.signupRedirectionUrl);
    const { profileUrl } = getProfileInfo(updatedUser);
    const redirectionUrl = !isEmpty(signupRedirectionUrl) ? signupRedirectionUrl : "/";
    window.location.href = redirectionUrl;
  } catch (errors) {
    yield put(setToastMessage({ msg: "Updating profile failed!", type: TOAST_FAIL }));
    yield put(fetchInProgress({ key: "onboarding-enthusiast", status: false }));
  }
}

function* validateOnBoardingEnthusiastForm(payload: SetProfileStatePayload) {
  const { fullName, profileImage } = payload;

  const hasAtLeastTwoNames = /\w +\w/.test(fullName);
  if (isEmpty(fullName) || !hasAtLeastTwoNames) {
    yield put(setToastMessage({ msg: "Please enter your first and last name", type: TOAST_ALERT }));
    return false;
  }

  return true;
}

export function* watchOnBoardingEnthusiast() {
  yield takeEvery(ONBOARDING_ENTHUSIAST, onBoardingEnthusiastWorker);
}
